import { render, staticRenderFns } from "./InfoMethod.vue?vue&type=template&id=864e581e&scoped=true&"
import script from "./InfoMethod.vue?vue&type=script&lang=js&"
export * from "./InfoMethod.vue?vue&type=script&lang=js&"
import style0 from "./InfoMethod.vue?vue&type=style&index=0&id=864e581e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864e581e",
  null
  
)

export default component.exports